import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../common/VideoPlayerModal';

const AARPGames = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const l1 = []
    const l2 = []
    const l3 = []

    for (let index = 1; index < 63; index++) {
        if(index < 22 ) {
            l1.push(<img id={index} src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/games-icon/cg_" + index +".jpg"} alt={index} className='aarp-image-slider-auto mx-4' key={index} />)
        }
        else if (index >= 22 && index < 42 ) {
            l2.push(<img id={index} src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/games-icon/cg_" + index +".jpg"} alt={index} className='aarp-image-slider-auto mx-4' key={index} />)
        }
        else {
            l3.push(<img id={index} src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/games-icon/cg_" + index +".jpg"} alt={index} className='aarp-image-slider-auto mx-4' key={index} />)
        }
        
    }

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }
  return (
    <>
 
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
           <Row className=''>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card.Title className='vr-healthcare-title'>VR Casual Games</Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    We have developed for VR 70 casual brain stimulation/training games that were launched as the Staying Sharp series of casual games in AARP’s Alcove VR App. In addition, we have developed 20 board games for play in VR as well as AR, as we demoed with AARP at CES 2020.
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/casual-games/video/CasualGames.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/aarp_001.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>

                    </Card>
                </Col>
                </Row>
                <Row className='px-md-4'>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail aarp-images' src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/aarp_004.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail aarp-images' src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/aarp_003.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail aarp-images' src={process.env.PUBLIC_URL + "assets/vr-development/casual-games/aarp_002.jpg"} />
                </Col>
            </Row>
        </Card>
        <Card className='no-border rounded-0 pb-md-5'>
            <Row>
                <Col>
                    <div className="aarp-parent">
                        <div className="aarp-child">{l1} </div>
                    </div>

                    <div className="aarp-parent-middle">
                        <div className="aarp-child-middle"> {l2} </div>
                    </div>


                    <div className="aarp-parent">
                        <div className="aarp-child"> {l3} </div>
                    </div>
                    </Col>
                </Row>
            </Card>

        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={videoUrl}
      />
      
    </>
  )
}

export default AARPGames
